import { createAction } from '@reduxjs/toolkit';

import type {
  CreateVariablePayload,
  DeleteVariablePayload,
  UpdateVariablePayload,
} from '@polyai/stream/commands/handlers/variables';

const PREFIX = 'variables';

const createVariable = createAction<CreateVariablePayload>(
  `${PREFIX}/createVariable`,
);

const updateVariable = createAction<UpdateVariablePayload>(
  `${PREFIX}/updateVariable`,
);

const deleteVariable = createAction<DeleteVariablePayload>(
  `${PREFIX}/deleteVariable`,
);

export { createVariable, deleteVariable, updateVariable };
